import React, { useState } from 'react';
import {
  focusEditor,
  useEventPlateId,
  usePlateEditorState,
  withoutNormalizing,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import ToolbarDropdown, { ToolbarDropdownButton } from './ToolbarDropdown';
import { insertEmptyElementAfter } from '../../utils/insertEmptyElementAfter';
import { insertTable } from '../../plugins/table/insertTable';

import './table-dropdown.scss';

const TableDropdown = ({ id }) => {
  const MAX_DIMENSION = 5;

  const [open, setOpen] = useState(false);
  const [rowCount, setRowCount] = useState(1);
  const [colCount, setColCount] = useState(1);

  const editor = usePlateEditorState(useEventPlateId(id));

  const show = () => {
    setOpen(true);
  };

  const dismiss = () => {
    setOpen(false);
  };

  const setDimensions = ({ row, col }) => {
    setRowCount(row);
    setColCount(col);
  };

  const addTable = (e) => {
    e.preventDefault();
    e.stopPropagation();
    withoutNormalizing(editor, () => {
      insertTable(editor, { rowCount, colCount });
      // Insert empty element after table so text can be added
      // underneath the table.
      insertEmptyElementAfter(editor, { mode: 'highest' });
    });

    dismiss();
    focusEditor(editor);
  };

  const trigger = (
    <ToolbarDropdownButton
      className="plate-toolbar__button toolbar-dropdown-button"
    >
      <FontAwesomeIcon icon={['fa', 'table']} />
    </ToolbarDropdownButton>
  );

  const rows = [];
  for (let i = 1; i <= MAX_DIMENSION; i += 1) {
    for (let j = 1; j <= MAX_DIMENSION; j += 1) {
      rows.push(
        <TableGridCell
          key={`table-cell-${i}x${j}`}
          setDimensions={setDimensions}
          row={i}
          col={j}
          maxDimension={MAX_DIMENSION}
          addTable={addTable}
          rowCount={rowCount}
          colCount={colCount}
        />,
      );
    }
  }

  return (
    <ToolbarDropdown
      isOpen={open}
      show={show}
      dismiss={dismiss}
      DropdownButton={trigger}
      name="table-dropdown"
      tooltipName="Insert table"
      className="plate-toolbar__dropdown-button table-dropdown"
    >
      <div className="table-grid">
        <div className="table-grid__selection">
          {rows}
        </div>
        <div className="table-grid__indicator">
          {rowCount} x {colCount}
        </div>
      </div>
    </ToolbarDropdown>
  );
};

const TableGridCell = ({
  setDimensions,
  addTable,
  row,
  col,
  maxDimension,
  rowCount,
  colCount,
}) => {
  const widthPercentage = 100 / maxDimension;
  const active = row <= rowCount && col <= colCount;
  return (
    <button
      className={clsx('table-grid__cell', 'button--unstyled', active && 'table-grid__cell--active')}
      onMouseEnter={() => setDimensions({ row, col })}
      onClick={addTable}
      style={{ width: `calc(${widthPercentage}% - 4px)`, height: '16px' }}
    />
  );
};

export default TableDropdown;
